import axiosInstance from "../api/axiosInstance";
import API_ENDPOINTS from "../api/endpoints";

const reportService = {
  payrollSummaryReport: (params) =>
    axiosInstance.get(API_ENDPOINTS.Report.PAYROLL_SUMMARY_REPORT, {
      params,
      responseType: "blob",
    }),

  taxLiabilityReport: (params) =>
    axiosInstance.get(API_ENDPOINTS.Report.TAX_LIABILITY_REPORT, {
      params,
      responseType: "blob",
    }),
};

export default reportService;
